export default {};
throw new Error(`Could not resolve "@react-three/postprocessing" imported by "@appletosolutions/reactbits". Is it installed?`)